(function () {
  const HIDDEN = 'linkedin-news-m__nav--hidden';

  function getGapPx(el) {
    const styles = window.getComputedStyle(el);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return gap;
  }

  function setNavShown(btn, shown) {
    btn.classList.toggle(HIDDEN, !shown);
    if (!shown && document.activeElement === btn) btn.blur();
  }

  function init(root) {
    if (root.dataset.linkedinNavInit === '1') return;

    const scroller = root.querySelector('[data-linkedin-scroll]');
    const prev = root.querySelector('[data-linkedin-prev]');
    const next = root.querySelector('[data-linkedin-next]');
    if (!scroller || !prev || !next) return;

    root.dataset.linkedinNavInit = '1';

    function getStep() {
      const slide = scroller.querySelector('.linkedin-news-m__slide');
      if (!slide) return Math.max(280, scroller.clientWidth * 0.9);
      const gap = getGapPx(scroller);
      return slide.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const sl = scroller.scrollLeft;

      if (maxScroll <= 1) {
        setNavShown(prev, false);
        setNavShown(next, false);
        return;
      }

      /* Tolerancja skalowana — przy krótkim torze unik „atEnd” na starcie */
      const tol = Math.min(12, Math.max(2, maxScroll * 0.04));
      const atStart = sl <= tol;
      const atEnd = maxScroll > tol && sl >= maxScroll - tol;

      setNavShown(prev, !atStart);
      setNavShown(next, !atEnd);
    }

    function scheduleNavUpdates() {
      updateNav();
      [50, 150, 350, 600].forEach((ms) => {
        window.setTimeout(updateNav, ms);
      });
    }

    prev.addEventListener('click', () => {
      scroller.scrollBy({ left: -getStep(), behavior: 'smooth' });
      scheduleNavUpdates();
    });

    next.addEventListener('click', () => {
      scroller.scrollBy({ left: getStep(), behavior: 'smooth' });
      scheduleNavUpdates();
    });

    scroller.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav, { passive: true });
    scroller.addEventListener('scrollend', updateNav, { passive: true });

    updateNav();
  }

  function initFromEventTarget(target) {
    if (!target || !target.querySelector) return;
    const root = target.matches('[data-linkedin-news]') ? target : target.querySelector('[data-linkedin-news]');
    if (root) init(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-linkedin-news]').forEach(init);
  });

  document.addEventListener('shopify:section:load', (ev) => {
    initFromEventTarget(ev.target);
  });
})();
